import * as React from "react";
import { forwardRef } from "react";
const SvgAlert = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z" }));
const ForwardRef = forwardRef(SvgAlert);
export default ForwardRef;
